'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var _functions = require('./functions');

var _functions2 = _interopRequireDefault(_functions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Parse a latex math string, to an object
 * @param  {string} latex A latex string like "\frac{1}{2}"
 * @return {array} An array containing the content of the input,
 *                     formatted with objects with a type and a value field
 */
var parseLatex = function parseLatex(latex) {
  var findingToken = false;
  var findingNumber = false;
  var findingVariable = false;
  var currentToken = '';
  var currentNumber = '';
  var currentVariable = '';
  var structure = [];

  for (var i = 0; i < latex.length; i++) {
    var char = latex.charAt(i);

    if (findingToken) {
      if (char.match(/[a-zA-Z]/g)) {
        currentToken += char;
        continue;
      } else {
        if ((currentToken + char).match(/^\s+$/g)) {
          currentToken = ' ';
        }
        findingToken = false;
        _logger2.default.debug('Found token ' + currentToken);
        parseToken(currentToken, structure);
        currentToken = '';
      }
    }

    if (findingNumber) {
      // Check for number
      if (char.match(/[\d.,]/g)) {
        _logger2.default.debug('Found next number in sequence: ' + char);
        currentNumber += char;
        continue;
      } else {
        _logger2.default.debug('Number found ' + currentNumber);
        structure.push({
          type: 'number',
          value: currentNumber
        });

        currentNumber = '';
        findingNumber = false;
      }
    } else {
      if (char.match(/[\d.,]/g)) {
        _logger2.default.debug('Found a new number: ' + char);
        currentNumber += char;
        findingNumber = true;
        continue;
      }
    }

    if (findingVariable && !char.match(/[a-zA-Z]/g)) {
      structure.push({
        type: 'variable',
        value: currentVariable
      });
      findingVariable = false;
      _logger2.default.debug('Found new variable ' + currentVariable);
    }

    // Check for group '{ ... }'
    if (char === '\\') {
      findingToken = true;
      continue;
    } else {
      if (char === '{') {
        var length = matchingBracketLength(latex.substr(i), 'curly');

        if (length instanceof Error) return length;

        var newLatex = latex.substr(i + 1, length - 1);
        _logger2.default.debug('New Latex' + newLatex);

        structure.push({
          type: 'group',
          value: parseLatex(newLatex)
        });

        i += length;
        continue;
      }

      // Check for operator
      if (char.match(/[+\-*/()=^_]/g)) {
        _logger2.default.debug('Found operator ' + char);
        structure.push({
          type: 'operator',
          value: char
        });
        continue;
      }

      // Check for variable
      if (char.match(/[a-zA-Z]/g)) {
        if (findingVariable) {
          currentVariable += char;
          _logger2.default.debug('- Finding variable ' + currentVariable);
        } else {
          currentVariable = char;
          findingVariable = true;
          _logger2.default.debug('Finding new variable ' + currentVariable);
        }
      }
    }
  } // Loop end

  if (findingNumber) {
    _logger2.default.debug('Wrapping up number');
    structure.push({
      type: 'number',
      value: currentNumber
    });
  }

  if (findingToken) {
    _logger2.default.debug('Wrapping up token');
    structure.push({
      type: 'token',
      value: currentToken
    });
  }

  if (findingVariable) {
    _logger2.default.debug('Wrapping up variable');
    structure.push({
      type: 'variable',
      value: currentVariable
    });
  }

  return structure;
};

var parseToken = function parseToken(token, structure) {
  var isFunction = _functions2.default.reduce(function (acc, val) {
    return acc || val === token;
  }, false);
  if (isFunction) {
    structure.push({
      type: 'function',
      value: token
    });
    return;
  }
  switch (token) {
    case 'cdot':
      structure.push({
        type: 'operator',
        value: '*'
      });
      break;
    case 'mod':
      structure.push({
        type: 'operator',
        value: '%'
      });
      break;
    default:
      structure.push({
        type: 'token',
        value: token
      });
  }
};

/**
 * Will find the length to the matching bracket, in provided string
 * @param  {string} latex       A string of latex, starting from where the search should begin
 * @param  {string} bracketType The type of bracket to search for.
 *                                  Can be one of the following ['normal', 'curly', 'square']
 * @return {number}             The length from start of provided string,
 *                                  to the location of the matching bracket
 */
var matchingBracketLength = function matchingBracketLength(latex, bracketType) {
  _logger2.default.debug('Finding matching bracket for text:', latex);

  var startBracket = '';
  var endBracket = '';

  switch (bracketType) {
    case 'normal':
      startBracket = '(';
      endBracket = ')';
      break;
    case 'curly':
      startBracket = '{';
      endBracket = '}';
      break;
    case 'square':
      startBracket = '[';
      endBracket = ']';
      break;
  }

  var bracketDepth = 0;

  for (var i = 0; i < latex.length; i++) {
    var char = latex.charAt(i);
    _logger2.default.debug('-- Char:' + char);

    if (char === startBracket) {
      bracketDepth++;
      _logger2.default.debug('-- Found starting bracket, depth ' + bracketDepth);
    } else if (char === endBracket) {
      if (bracketDepth === 1) {
        _logger2.default.debug('-- Found original closing bracket at position ' + i);
        return i;
      }

      bracketDepth--;
      _logger2.default.debug('-- Found closing bracket, depth ' + bracketDepth);
    }
  }

  return new Error('Brackets do not match up');
};

exports.default = parseLatex;


// WEBPACK FOOTER //
// ./~/algebra-latex/lib/parser.js